module.exports = __webpack_public_path__ + "static/media/heroBanner.12b44e95.png";